import { atom, useAtom } from "@libraries/jotai";

const permissionsAtom = atom<string[]>([]);

export default function usePermissions() {
  const [value, setValue] = useAtom(permissionsAtom);

  return { value, setValue };
}